<template>
	<Users v-bind="$attrs" :name="name" :users="false" :label="label"></Users>
</template>

<script setup lang="ts">
import Users from './Users.vue'

defineProps({
	name: {
		type: String,
		default: 'persons',
	},
	label: {
		type: String,
		default: 'Personen',
	},
})
</script>

<style scoped></style>
